<template>
  <div class="google-map" id="map"></div>
</template>

<script>
/* global google */
import firebase from 'firebase'
import db from '../firebase'

export default {
  name: 'Map',

  data () {
    return {
      lat: 23,
      lng: 87
    }
  },

  methods: {
    renderMap () {
      // eslint-disable-next-line no-undef
      const map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: this.lat, lng: this.lng },
        zoom: 6,
        maxZoom: 15,
        minZoom: 2,
        streetViewControl: false
      })

      db.collection('users')
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            const data = doc.data()
            if (data.geolocation) {
              const marker = new google.maps.Marker({
                position: {
                  lat: data.geolocation.lat,
                  lng: data.geolocation.lng
                },
                map
              })
              marker.addListener('click', () => {
                this.$router.push({ name: 'Profile', params: { id: doc.id } })
              })
            }
          })
        })
    }
  },

  mounted () {
    // Get the current user
    const user = firebase.auth().currentUser
    // Get User Geo-Location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        pos => {
          this.lat = pos.coords.latitude
          this.lng = pos.coords.longitude

          // Updating User's geo location at firebase
          db.collection('users')
            .where('user_id', '==', user.uid)
            .get()
            .then(snapshot => {
              snapshot.forEach(doc => {
                db.collection('users')
                  .doc(doc.id)
                  .update({
                    geolocation: {
                      lat: pos.coords.latitude,
                      lng: pos.coords.longitude
                    }
                  })
              })
            })
            .then(() => {
              this.renderMap()
            })
        },
        err => {
          console.log(err)
          this.renderMap()
        },
        { maximumAge: 60000, timeout: 3000 }
      )
    }
  }
}
</script>

<style>
.google-map {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: absolute;
  background: #fff;
  top: 0;
  left: 0;
}
</style>
